export default __webpack_public_path__ + "static/media/add-icon.4a246233.svg";